import type { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

// Zoneless change detection (the Angular 21+ default): no zone.js, components are OnPush.
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withXhr()),
    // Prerendered pages are hydrated; clicks before hydration are replayed.
    provideClientHydration(withEventReplay()),
  ],
};
